import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TransferInService {
  private baseUrl = `${environment.apiUrl}/stock-transfer-in`;

  constructor(private http: HttpClient) {}

  createTransferIn(body: any) {
    return this.http.post(`${this.baseUrl}`, body);
  }

  getTransferIns(
    pageOptions: { page: number; limit: number },
    searchText: string = '',
    filters?: { status?: string }
  ) {
    let params = new HttpParams()
      .set('page', pageOptions.page)
      .set('limit', pageOptions.limit);
    if (searchText) {
      params = params.set('search', searchText);
    }
    if (filters?.status) {
      params = params.set('status', filters.status);
    }
    return this.http.get(`${this.baseUrl}`, { params });
  }

  finalizeTransferIn(id: string) {
    return this.http.post(`${this.baseUrl}/${id}/post`, {});
  }

  getNextTransferInNumber() {
    return this.http.get(`${this.baseUrl}/next-number`);
  }

  getTransferInById(id: string) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }
}
